const {env} = require("./vars.js");
let viewerUrl
let appURL

let baseUrl;

if (env === "dev") {
  viewerUrl = 'https://viewer-dev.vendict.com/'
  baseUrl = "https://api-dev.vendict.com/";
  appURL = 'https://app-dev.vendict.com/'

} else if (env === "qa") {
  viewerUrl = 'https://viewer-qa.vendict.com/'
  baseUrl = "https://api-qa.vendict.com/";
  appURL = 'https://app-qa.vendict.com/'

} else if (env === "prod") {
  viewerUrl = 'https://viewer.vendict.com/'
  baseUrl = "https://api.vendict.com/";
  appURL = 'https://myapp.vendict.com/'

} else {
  viewerUrl = 'https://viewer.vendict.com/'
  baseUrl = "https://api-dev.vendict.com/";
  appURL = 'https://myapp.vendict.com/'

}

let authConfig;
let firestoreConfig;
if (env === "dev") {
  // Firebase config for project AAA (Auth)
  authConfig = {
    apiKey: "AIzaSyBTGKhOChlIyUuicPffmI9PV2DLVvlXhME",
    authDomain: "vendict-trust-dev.firebaseapp.com",
    projectId: "vendict-trust-dev",
    storageBucket: "vendict-trust-dev.appspot.com",
    messagingSenderId: "901856795992",
    appId: "1:901856795992:web:474fd7c6a7ade61f76592d"
  };

// Firebase config for project BBB (Firestore)
  firestoreConfig = {
    apiKey: "AIzaSyDFRtGT4aKqGkPjGniezskwt8QLgKBYBtQ",
    authDomain: "vendictdev.firebaseapp.com",
    databaseURL: "https://vendictdev.firebaseio.com",
    projectId: "vendictdev",
    storageBucket: "vendictdev.appspot.com",
    messagingSenderId: "933936175275",
    appId: "1:933936175275:web:92cb1e796c033a8de67fee",
    measurementId: "G-9D7KDK7VGX",
  };
} else if (env === "qa") {

  // Firebase config for project AAA (Auth)
  authConfig = {
    apiKey: "AIzaSyBTkPd8lBe701bOoYSfn61u0N3AnnGRqpo",
    authDomain: "vendict-trust-qa.firebaseapp.com",
    projectId: "vendict-trust-qa",
    storageBucket: "vendict-trust-qa.appspot.com",
    messagingSenderId: "388174531593",
    appId: "1:388174531593:web:1415a900eba4b7ea9c3cd8"
  };

// Firebase config for project BBB (Firestore)
  firestoreConfig = {
    apiKey: "AIzaSyBtu_3hZ7LMTJgSoiHvQQtyf9Lx84Smltw",
    authDomain: "vendictqa.firebaseapp.com",
    databaseURL: "https://vendictqa.firebaseio.com",
    projectId: "vendictqa",
    storageBucket: "vendictqa.appspot.com",
    messagingSenderId: "699111289272",
    appId: "1:699111289272:web:c98d9c3a08e570f8421f4d",
    measurementId: "G-5CDL6TDCRG",
  };
} else if (env === "prod") {
  // Firebase config for project AAA (Auth)
  authConfig = {
    apiKey: "AIzaSyBo25J64ZXFPfEFIUT2j34ll848yG2ZVbU",
    authDomain: "vendict-trust.firebaseapp.com",
    projectId: "vendict-trust",
    storageBucket: "vendict-trust.appspot.com",
    messagingSenderId: "240182450911",
    appId: "1:240182450911:web:f87508cf188b26ad47676a"
  };

// Firebase config for project BBB (Firestore)
  firestoreConfig = {
    apiKey: "AIzaSyCvrNiViqJBk4_5-ot4na2QL_Wm7FXxHYQ",
    authDomain: "vendictbeta.firebaseapp.com",
    projectId: "vendictbeta",
    storageBucket: "vendictbeta.appspot.com",
    messagingSenderId: "504629978168",
    appId: "1:504629978168:web:2e694c44697360c9fc72cd",
    measurementId: "G-KW2L6FSXKR",
  };
}


module.exports = {
  baseUrl,
  env,
  viewerUrl,
  appURL,
  authConfig,
  firestoreConfig,
};
